module.exports = __webpack_public_path__ + "media/bootstrap-icons/filter-square-fill-87e52fd2.svg";